export enum merchantActionTypes {
	FETCH_STATUS_SUCCESS = 'FETCH_STATUS_SUCCESS',
	FETCH_APPLICATION_DATA_SUCCESS = 'FETCH_APPLICATION_DATA_SUCCESS',
	FETCH_FEES_DATA_SUCCESS = 'FETCH_FEES_DATA_SUCCESS',
	FETCH_FAIL = 'FETCH_FAIL',
	FETCH_MERCHANTS_LISTS = 'FETCH_MERCHANTS_LISTS',
	START_WIDGET_CONFIGURATIONS_LOADING = 'START_WIDGET_CONFIGURATIONS_LOADING',
	FETCH_WIDGET_CONFIGURATION_DATA = 'FETCH_WIDGET_CONFIGURATION_DATA',
	SET_MERCHANT_DETAILS_DATA_DEFAULT = 'SET_MERCHANT_DETAILS_DATA_DEFAULT',
	FETCH_MERCHANT_DATA = 'FETCH_MERCHANT_DATA',
	FETCH_PARTNER_LIST_SELECTOR = 'FETCH_PARTNER_LIST_SELECTOR',
	FETCH_SALES_AGENCY_LIST_SELECTOR = 'FETCH_SALES_AGENCY_LIST_SELECTOR',
	SET_PARTNER_LIST_DATA_LOADING = 'SET_PARTNER_LIST_DATA_LOADING',
	FETCH_PARTNER_LIST = 'FETCH_PARTNER_LIST',
	SET_PARTNER_LIST_DEFAULT = 'SET_PARTNER_LIST_DEFAULT',
	FETCH_MERCHANT_FEES = 'FETCH_MERCHANT_FEES',
	FETCH_MERCHANT_FEE_HISTORY = 'FETCH_MERCHANT_FEE_HISTORY',
	START_LOADING = 'START_LOADING',
	END_LOADING = 'END_LOADING',
	FETCH_MERCHANTS = 'FETCH_MERCHANTS',
	FETCH_STANDARD_FEES = 'FETCH_STANDARD_FEES',
	FETCH_FEE = 'FETCH_FEE',
	SET_APPLICATION_DATA_LOADING = 'SET_APPLICATION_DATA_LOADING',
	FETCH_APPLICATION_DATA = 'FETCH_APPLICATION_DATA',
	FETCH_IS_STANDARD_FEE_SELECTED = 'FETCH_IS_STANDARD_FEE_SELECTED',
	SET_APPLICATION_DETAILS_DATA_DEFAULT = 'SET_APPLICATION_DETAILS_DATA_DEFAULT',
	FETCH_MERCHANTS_LIST_REPORT = 'FETCH_MERCHANTS_LIST_REPORT',
	FETCH_MERCHANTS_LIST_REPORT_DATA = 'FETCH_MERCHANTS_LIST_REPORT_DATA',
	START_NEW_PARTNER_LOADING = 'START_NEW_PARTNER_LOADING',
	END_NEW_PARTNER_LOADING = 'END_NEW_PARTNER_LOADING',
	SET_GENERAL_ERROR = 'SET_GENERAL_ERROR',
	FETCH_SITES_LIST = 'FETCH_SITES_LIST',
	START_SITES_LIST_LOADING = 'START_SITES_LIST_LOADING',
	START_WEBHOOK_EVENT_TYPES_LOADING = 'START_WEBHOOK_EVENT_TYPES_LOADING',
	FETCH_WEBHOOK_EVENT_TYPES = 'FETCH_WEBHOOK_EVENT_TYPES',
	START_WEBHOOK_LOGS_LOADING = 'START_WEBHOOK_LOGS_LOADING',
	FETCH_WEBHOOK_LOGS_DATA = 'FETCH_WEBHOOK_LOGS_DATA',
	SET_WEBHOOK_LOGS_TABLE_PAGINATION = 'SET_WEBHOOK_LOGS_TABLE_PAGINATION',
	FETCH_LIST_OF_MERCHANTS = 'FETCH_LIST_OF_MERCHANTS',
	START_LIST_OF_MERCHANTS_LOADING = 'START_LIST_OF_MERCHANTS_LOADING',
	SET_CHOSEN_MERCHANT = 'SET_CHOSEN_MERCHANT',
	SET_MERCHANT_FEES = 'SET_MERCHANT_FEES',
	SET_DEFAULT_FEE = 'SET_DEFAULT_FEE',
	SET_ALL_DEFAULT_FEE = 'SET_ALL_DEFAULT_FEE',
	SET_GLOBAL_LOADING = 'SET_GLOBAL_LOADING',
	START_FETCH_CHECKOUT_LOADING = 'START_FETCH_CHECKOUT_LOADING',
	FETCH_CHECKOUT_CONFIGURATION = 'FETCH_CHECKOUT_CONFIGURATION',
	FETCH_MCC_LIST = 'FETCH_MCC_LIST',
	FETCH_SFTP_CONFIG = 'FETCH_SFTP_CONFIG',
	START_SFTP_CONFIG_LOADING = 'START_SFTP_CONFIG_LOADING',
	FETCH_AGENCY_LIST = 'FETCH_AGENCY_LIST',
	SET_AGENCY_LIST_LOADING = 'SET_AGENCY_LIST_LOADING',
	SET_NEW_AGENCY_CREATION_LOADING = 'SET_NEW_AGENCY_CREATION_LOADING',
	SET_CREATING_NEW_SALES_AGENT_LOADING = 'SET_CREATING_NEW_SALES_AGENT_LOADING',
	SET_MERCHANT_NAMES = 'SET_MERCHANT_NAMES',
	SET_PARTNER_NAMES = 'SET_PARTNER_NAMES',
	SET_PARTNER_NAMES_LOADING = 'SET_PARTNER_NAMES_LOADING',
	GET_SENSE_JS_VALIDATION_RESULT = 'GET_SENSE_JS_VALIDATION_RESULT',
	START_SENSE_JS_VALIDATION_LOADING = 'START_SENSE_JS_VALIDATION_LOADING',
	SET_ACCOUNT_LIST_LOADING = 'SET_ACCOUNT_LIST_LOADING',
	FETCH_ACCOUNT_LIST = 'FETCH_ACCOUNT_LIST',
	SET_NEW_ACCOUNT_LOADING = 'SET_NEW_ACCOUNT_LOADING',
	SET_ACCOUNTS_LIST_SELECTOR = 'SET_ACCOUNTS_LIST_SELECTOR',
	SET_PLATFORM_SYSTEM = 'SET_PLATFORM_SYSTEM',
	SET_FUNDS_RESERVE_CONFIG_ACTIVE_LIST_DATA_LOADING = 'SET_FUNDS_RESERVE_CONFIG_ACTIVE_LIST_DATA_LOADING',
	SET_FUNDS_RESERVE_CONFIG_INACTIVE_LIST_DATA_LOADING = 'SET_FUNDS_RESERVE_CONFIG_INACTIVE_LIST_DATA_LOADING',
	FETCH_FUNDS_RESERVE_CONFIG_ACTIVE = 'FETCH_FUNDS_RESERVE_CONFIG_ACTIVE',
	FETCH_FUNDS_RESERVE_CONFIG_INACTIVE = 'FETCH_FUNDS_RESERVE_CONFIG_INACTIVE',
	FETCH_FUNDS_RESERVE_CONFIG_LISTS = 'FETCH_FUNDS_RESERVE_CONFIG_LISTS',
	SET_MERCHANT_FUNDS_RESERVE_CONFIG_LOADING = 'SET_MERCHANT_FUNDS_RESERVE_CONFIG_LOADING',
	SET_PARTNER_FEES_LOADING = 'SET_PARTNER_FEES_LOADING',
	FETCH_PARTNER_FEES = 'FETCH_PARTNER_FEES',
	SET_PARTNER_FEES_ADDING_LOADING = 'SET_PARTNER_FEES_ADDING_LOADING',
	SET_PARTNER_BANK_LOADING = 'SET_PARTNER_BANK_LOADING',
	FETCH_PARTNER_BANK = 'FETCH_PARTNER_BANK',
	SET_INTEGRATION_PARTNER_LIST_LOADING = 'SET_INTEGRATION_PARTNER_LIST_LOADING',
	FETCH_INTEGRATION_PARTNER_LIST_SELECTOR = 'FETCH_INTEGRATION_PARTNER_LIST_SELECTOR',
	SET_AUDIT_LOGS_LOADING = 'SET_AUDIT_LOGS_LOADING',
	FETCH_AUDIT_LOGS_LIST = 'FETCH_AUDIT_LOGS_LIST',
	SET_AUDIT_LOGS_TABLE_PAGINATION = 'SET_AUDIT_LOGS_TABLE_PAGINATION',
	SET_WHITELABEL_PARTNER_LIST_LOADING = 'SET_WHITELABEL_PARTNER_LIST_LOADING',
	FETCH_WHITELABEL_PARTNER_LIST_SELECTOR = 'FETCH_WHITELABEL_PARTNER_LIST_SELECTOR',
	SET_SIGN_UP_LOADING = 'SET_SIGN_UP_LOADING',
	SET_CONFIRM_AGREEMENT = 'SET_CONFIRM_AGREEMENT',
	SET_QUICK_APP_LOADING = 'SET_QUICK_APP_LOADING',
	SET_QUICK_APP_DATA_LOADING = 'SET_QUICK_APP_DATA_LOADING',
	SET_QUICK_APP_DATA = 'SET_QUICK_APP_DATA',
	SET_APPLICATION_SUMMARY_LOADING = 'SET_APPLICATION_SUMMARY_LOADING',
	FETCH_APPLICATION_SUMMARY = 'FETCH_APPLICATION_SUMMARY',
	IS_APPLICATION_VIEW_DATA_LOADING = 'IS_APPLICATION_VIEW_DATA_LOADING',
	FETCH_APPLICATION_VIEW = 'FETCH_APPLICATION_VIEW',
	SET_APPLICATION_DATA_TO_DEFAULT = 'SET_APPLICATION_DATA_TO_DEFAULT',
	FETCH_APPLICATION_VIEW_FEES = 'FETCH_APPLICATION_VIEW_FEES',
	IS_SET_APPLICATION_VIEW_DATA_LOADING = 'IS_SET_APPLICATION_VIEW_DATA_LOADING',
	IS_APPLICATION_VIEW_DATA_SUBMISSION_LOADING = 'IS_APPLICATION_VIEW_DATA_SUBMISSION_LOADING',
	FETCH_WORKFLOWS = 'FETCH_WORKFLOWS',
	SET_WORKFLOWS_LOADING = 'SET_WORKFLOWS_LOADING',
	SET_APPLICATION_EDIT_STATUS = 'SET_APPLICATION_EDIT_STATUS',
	SET_RISK_MODAL_LOADING = 'SET_RISK_MODAL_LOADING',
	SET_REINVITE_LOADING = 'SET_REINVITE_LOADING',
	SET_DOCUMENT_LOADING = 'SET_DOCUMENT_LOADING',
	FETCH_APPLICATION_DETAILS_LOGS = 'FETCH_APPLICATION_DETAILS_LOGS',
	SET_APPLICATION_DETAILS_LOGS_LOADING = 'SET_APPLICATION_DETAILS_LOGS_LOADING',
	SET_PARTNER_DETAILS_DEFAULT = 'SET_PARTNER_DETAILS_DEFAULT',
	FETCH_PARTNER_DETAILS = 'FETCH_PARTNER_DETAILS',
	SET_PARTNER_FILTERS = 'SET_PARTNER_FILTERS',
}
